module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAjCAYAAAD17ghaAAAAAXNSR0IArs4c6QAAAUtJREFUWAntmLFKA0EQhmeGEB9ACAn4GDYShLR5EC1CWhtFK7HRMljog9gGJNr4GIIi2Nl4xY77x5uwJB6Gc5MgzMAxd7N78+38t3DMMpXWvX7bDxqOmGhXVTsWz+mZ+UWJnoTlcjJo3SN35BF1R6/HgemcVKfPiK3WOAjR6WTYvuBp5SGMiTTG1mlxESK9BmSfwZnutprNw/HB9vP8UvZGUO/bHoedWkr1bt93PovihpT6YIIt+OaWuApu43/1KAwMywO2pBvup8ptci6fMsBe83dfLMMX4Ar8KwWKcg+bX9zSNSJLK8DCV/Fn8gFfg1P5SqNyZG7gYdA+iSFcWW1pBbJSk2S+AFfAFXAFXAFXwBUQdKz2d0TrZPer8ikDbEG7bDD0bekEi+fys96wTAj2xrtjwUEBM53Fo4KQq9Lf85TnA2Db5E2dkHwBBqd9bt1f3cgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/icon/footer-new-word-active.png
// module id = 9PUD
// module chunks = 1